import { render } from "./SettingsApiTokensAdd.vue?vue&type=template&id=4d0846e0"
import script from "./SettingsApiTokensAdd.vue?vue&type=script&lang=js"
export * from "./SettingsApiTokensAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__